import PropTypes from 'prop-types';

const CreateEditReferenceSection = ({ title, children, flush = false }) => (
  <section>
    <p className="text-xs font-medium text-gray-500">{title}</p>
    {flush ? (
      <div className="mt-2 min-w-0">{children}</div>
    ) : (
      <div className="receipt-card-elevate mt-2">
        <div className="receipt-card-surface p-4">{children}</div>
      </div>
    )}
  </section>
);

CreateEditReferenceSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  /** 表格等內容滿版：略過 receipt 卡片與內距 */
  flush: PropTypes.bool,
};

export default CreateEditReferenceSection;
